<template>
  <modal
    ref="modal"
    :show="show"
    :hide-footer="true"
    :hide-header="true"
    @hidden="$emit('input', false)"
  >
    <custom-field-editor
      :custom-field="customField"
      :project-id="projectId"
      :org-id="orgId"
      :team-id="teamId"
      :enable-after-creation="enableAfterCreation"
      :display-after-creation="displayAfterCreation"
      @created="closeAndEmit('created')"
      @saved="closeAndEmit('saved')"
      @deleted="closeAndEmit('deleted')"
      @back="hideModal"
    />
  </modal>
</template>

<script>
import CustomFieldEditor from '@/components/CustomFieldEditor.vue'
import Modal from '@/components/Modal.vue'

/**
 * This shows custom field's edit view in a modal
 */
export default {
  name: 'CustomFieldEditorModal',
  components: { CustomFieldEditor, Modal },
  props: [
    'show',
    'orgId',
    'projectId',
    'teamId',
    'customField',
    'enableAfterCreation',
    'displayAfterCreation'
  ],
  model: {
    prop: 'show'
  },
  computed: {},
  methods: {
    hideModal() {
      this.$refs.modal.hide()
    },
    closeAndEmit(eventName) {
      this.$emit(eventName)
      this.hideModal()
    }
  }
}
</script>

<style scoped lang="scss"></style>
